import React from 'react';

const PrivacyPolicy = () => {
    return (
      <section className="sm:py-20 px-10 my-20">
    <div className="max-w-4xl mx-auto p-6 bg-white rounded-lg shadow-md">
      <h1 className="text-4xl font-bold mb-6 text-center text-gray-800">Privacy Policy for BatchuGold</h1>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-2 text-gray-700">Introduction</h2>
        <p className="text-gray-600">
          Welcome to BatchuGold! Your privacy is important to us, and we are committed to protecting it. This privacy policy explains how we collect, use, and safeguard your personal information.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-2 text-gray-700">Contact Information</h2>
        <p className="text-gray-600"><strong>Company Name:</strong> BatchuGold</p>
        <p className="text-gray-600"><strong>Email:</strong> mail@batchugold.com</p>
        <p className="text-gray-600"><strong>Phone Number:</strong> +91 95195 19581</p>
        <p className="text-gray-600"><strong>Office Address:</strong> 3-12, Jagadeesh Market, 4, Mahankali St, General Bazaar, Kalasiguda, Secunderabad, Telangana 500003</p>
        <p className="text-gray-600"><strong>Manufacturing Address:</strong> Charminar, Hyderabad</p>
        <p className="text-gray-600"><strong>Website:</strong> <a href="http://www.batchugold.com" target="_blank" rel="noopener noreferrer" className="text-blue-500 hover:underline">www.batchugold.com</a></p>
        <p className="text-gray-600"><strong>Mobile Application:</strong> The Gold Jar</p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-2 text-gray-700">Information We Collect</h2>
        <p className="text-gray-600">We collect the following personal information from our users:</p>
        <ul className="list-disc list-inside text-gray-600">
          <li>Name</li>
          <li>Email address</li>
          <li>Phone number</li>
          <li>Sex</li>
          <li>Address</li>
        </ul>
        <p className="text-gray-600">Please note that we do not store any bank details. Transaction details are managed and stored by the payment gateway we use.</p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-2 text-gray-700">Cookies and Tracking Technologies</h2>
        <p className="text-gray-600">Our website uses cookies to collect data. Additionally, we use Google Analytics to gather and analyze information about how you use our site. This helps us improve our services and enhance your user experience.</p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-2 text-gray-700">Purpose of Data Collection</h2>
        <p className="text-gray-600">The personal information we collect is used for marketing purposes. We use this data to provide you with information about our products, services, promotions, and updates that may interest you.</p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-2 text-gray-700">Data Sharing</h2>
        <p className="text-gray-600">We value your privacy and assure you that your personal information is not shared with anyone.</p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-2 text-gray-700">Data Storage and Security</h2>
        <p className="text-gray-600">Your data is stored securely in our database, which is accessible only by a single authorized user to ensure your information is kept safe.</p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-2 text-gray-700">Your Rights</h2>
        <p className="text-gray-600">You have the right to:</p>
        <ul className="list-disc list-inside text-gray-600">
          <li>Access the personal information we hold about you.</li>
          <li>Request the correction of inaccurate personal information.</li>
          <li>Request the deletion of your personal information.</li>
          <li>Object to the processing of your personal information for marketing purposes.</li>
        </ul>
        <p className="text-gray-600">To exercise any of these rights, please contact us at mail@batchugold.com.</p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-2 text-gray-700">Changes to This Privacy Policy</h2>
        <p className="text-gray-600">We may update this privacy policy from time to time to reflect changes in our practices or for other operational, legal, or regulatory reasons. Any changes will be posted on this page.</p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-2 text-gray-700">Contact Us</h2>
        <p className="text-gray-600">If you have any questions or concerns about this privacy policy, please contact us at:</p>
        <p className="text-gray-600"><strong>Email:</strong> mail@batchugold.com</p>
        <p className="text-gray-600"><strong>Phone Number:</strong> +91 95195 19581</p>

        <p className="text-gray-600 mt-4">Thank you for choosing BatchuGold. We appreciate your trust in us and are committed to protecting your privacy.</p>

        <p className="text-gray-600 italic mt-4">This privacy policy was last updated on 10 june 2024.</p>
      </section>
    </div>
        </section>
    );
};

export default PrivacyPolicy